module.exports = __webpack_public_path__ + "img/logo-up-dejun.5a992f53.svg";